<template>
  <div v-if="!isElectron">
    <a
      v-if="showSidebar"
      class="arrow-button"
      @click="showSidebar = !showSidebar"
    >
      <eva-icon
        id="bar-arrow"
        name="arrow-back-outline"
        color="white"
        fill="#282A43"
      />
    </a>
    <div
      v-if="showSidebar"
      class="side-bar"
    >
      <div class="header">
        <img
          class="logo"
          src="@/assets/logo.svg"
        >
        <img
          class="cuidarte"
          src="@/assets/cuidarte.svg"
        >
      </div>
      <instance-picker
        v-if="hasMultipleAdmin || account.support"
        class="block mt-6"
      />
      <f7-button
        v-for="page in Object.keys(pages)"
        :key="page"
        :class="`sidebar-buttons ${actualPage !== pages[page].path ? 'unpressed-buttons': ''}`"
        :fill="actualPage === pages[page].path "
        @click="changePage(page)"
      >
        <eva-icon
          class="sidebar-buttons-icons"
          :name="pages[page].icon"
          color="white"
          fill="#FFFFFF"
        />
        {{ pages[page].name }}
      </f7-button>
      <hr>
      <f7-button
        v-if="hasAccess"
        :class="`sidebar-buttons ${actualPage !== '/user/' ? 'unpressed-buttons': ''}`"
        :fill="actualPage === '/user/' "
        href="/user/"
      >
        <eva-icon
          class="sidebar-buttons-icons"
          name="clipboard"
          color="white"
          fill="#FFFFFF"
        />
        Mis síntomas
      </f7-button>
      <f7-button
        v-if="hasAccess"
        :class="`sidebar-buttons ${actualPage !== '/user/' ? 'unpressed-buttons': ''}`"
        @click="askForLogout"
      >
        <eva-icon
          class="sidebar-buttons-icons"
          name="power-outline"
          color="white"
          fill="#FF7570"
        />
        Cerrar sesión
      </f7-button>
      <!-- <f7-button @click="exportAnswers()">
        exportAnswers
      </f7-button> -->
    </div>
    <div v-else>
      <a
        class="open-arrow-button"
        style="transform: scaleX(-1)"
        @click="showSidebar = !showSidebar"
      >
        <eva-icon
          id="bar-arrow"
          name="arrow-back-outline"
          color="white"
          fill="#282A43"
        />
      </a>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { db, firebaseTools } from '../utils/firebase'
import instancePicker from '@/components/instancePicker'
import moment from 'moment-timezone'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  name: 'Sidebar',
  components: {
    instancePicker,
  },
  props: {
    pages: { type: Object, default: () => {} },
  },
  data () {
    return {
      showSidebar: false,
      bindings: [],
      answers: {},
      questions: {},
      answersCategoryIDs: {},
    }
  },
  computed: {
    categories () {
      return this.instancesInfo[this.instanceID].dictionary.form.categories
    },
    categoryIDs () {
      return this.instancesInfo[this.instanceID].dictionary.form.categoryIDs
    },
    categoryNames () {
      return this.instancesInfo[this.instanceID].dictionary.form.categoryNames
    },
    isElectron () {
      return typeof window.ipcRenderer !== 'undefined'
    },
    hasMultipleAdmin () {
      return this.account.support || (this.account.administrator && this.account.administrator.length > 1)
    },
    hasAccess () {
      return !!this.account.accessibleInstances
    },
    ...mapState({
      actualPage: state => state.settings.actualPage,
      instanceID: state => state.admin.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
      account: state => state.auth.account,
      persons: state => state.admin.persons,
      auth: state => state.auth,
    }),
  },
  watch: {
    instanceID () {
      if (this.auth.isAdmin) {
        this.unbindAll()
        this.bindAll()
      }
    },
  },
  async mounted () {
    if (this.$f7.device.desktop) {
      this.showSidebar = true
    }
    if (this.auth.isAdmin) {
      this.bindAll()
    }
    if (this.auth.isObserver) {
      this.bindInstance()
      this.bindPersons()
    }
  },
  methods: {
    exportAnswers () {
      try {
        const todayDate = moment().tz('America/Bogota').startOf('day').format('DD-MM-YY')
        const wb = XLSX.utils.book_new()
        const csvTitle = 'Encuesta'
        const name = `Cuidarte-${todayDate}-${csvTitle}.xlsx`
        const questions = []
        console.info(Object.keys(this.answersCategoryIDs))
        for (const categoryID of Object.keys(this.answersCategoryIDs)) {
          for (const label of Object.keys(this.questions[categoryID])) {
            questions.push((this.categories[categoryID] ? this.categories[categoryID].name : 'Encuesta Quincenal') + ': ' + label)
          }
        }
        const complete = [
          ['Nombre', 'Celular', 'ID', 'email', ...questions],
          ...this.persons.map(person => {
            const personAnswers = []
            if (this.answers[person.id]) {
              for (const categoryID of Object.keys(this.answersCategoryIDs)) {
                for (const label of Object.keys(this.questions[categoryID])) {
                  if (this.answers[person.id][categoryID] && this.answers[person.id][categoryID].labels.includes(label)) {
                    personAnswers.push('X')
                  } else {
                    personAnswers.push('')
                  }
                }
              }
            }
            return [person.name, person.phoneNumber, person.documentID, person.email, ...personAnswers]
          })
        ]
        const w1 = XLSX.utils.aoa_to_sheet(complete)
        XLSX.utils.book_append_sheet(wb, w1, csvTitle.substring(0, 28) + (csvTitle.length >= 28 ? '...' : ''))

        const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
        const wbout = XLSX.write(wb, wopts)
        const xlsx = new Blob([wbout], { type: 'application/octet-stream' })

        if (typeof window.plugins !== 'undefined') {
          var reader = new FileReader()
          this.$f7.dialog.preloader('Cargando...')
          reader.readAsDataURL(xlsx)
          reader.onloadend = () => {
            this.$f7.dialog.close()
            const base64data = reader.result
            window.plugins.socialsharing.share(
              null,
              null,
              this.generateAttachment(base64data, name),
              null,
              (result) => { console.info('result: ' + result) },
              (result) => { console.info('error: ' + result) }
            )
          }
        } else {
          saveAs(xlsx, name)
        }
      } catch (err) {
        console.info(err)
        this.$f7.dialog.alert('Hubo un problema descargando este informe', 'Error')
      }
    },
    askForLogout () {
      this.$f7.dialog.confirm('¿Estás seguro de que deseas salir de tu cuenta?', 'Cerrar sesión', async () => {
        try {
          this.$f7.dialog.preloader('Eliminando datos locales...')
          await firebaseTools.signOut()
        } catch (err) {
          this.$f7.preloader.hide()
          console.error(err)
        }
      })
    },
    async bindAll () {
      moment.locale('es')
      this.bindInstance()
      this.bindings.push(db.collection('populations').where('instanceID', '==', this.instanceID).onSnapshot(populationQueries => {
        const populations = populationQueries.docs.map(population => {
          const populationData = population.data()
          return { id: population.id, ...populationData }
        })
        this.$store.commit('admin/setPopulations', populations)
      }, (err) => { console.info(err.code) }))
      this.bindPersons()
      this.bindings.push(db.collection('users').where('administrator', 'array-contains', this.instanceID).onSnapshot(administratorQueries => {
        const administrators = administratorQueries.docs.map(administrator => {
          return administrator.data().phoneNumber
        })
        this.$store.commit('admin/setAdministratorPhoneNumbers', administrators)
      }))
      this.bindings.push(db.collection('users').where('observer', 'array-contains', this.instanceID).onSnapshot(observerQueries => {
        const observers = observerQueries.docs.map(observer => {
          return observer.data().phoneNumber
        })
        this.$store.commit('admin/setObserverPhoneNumbers', observers)
      }))
      this.bindings.push(db.collection('users').where('accessibleInstances', 'array-contains', this.instanceID).where('accessPoint', '==', true).onSnapshot(accessPointQueries => {
        const accessPoints = accessPointQueries.docs.map(accessPoint => {
          return accessPoint.data().phoneNumber
        })
        this.$store.commit('admin/setAccessPointsPhoneNumbers', accessPoints)
      }))
      // const todayDate = moment().tz('America/Bogota').startOf('day').subtract(0, 'days').toDate()
      // const tomorrowDate = moment(todayDate).tz('America/Bogota').add(1, 'days').toDate()
      // this.bindings.push(db.collection('answers').where('instanceID', '==', this.instanceID).where('timestamp', '>=', todayDate).onSnapshot(answersQueries => {
      //   for (const answers of answersQueries.docs) {
      //     if (answers.data().timestamp.toDate() < tomorrowDate) {
      //       this.answers[answers.data().personID] = answers.data().answers
      //       for (const categoryID of Object.keys(answers.data().answers)) {
      //         this.answersCategoryIDs[categoryID] = true
      //         for (const label of answers.data().answers[categoryID].labels) {
      //           if (!this.questions[categoryID]) {
      //             this.questions[categoryID] = {}
      //           }
      //           this.questions[categoryID][label] = true
      //         }
      //       }
      //     }
      //   }
      //   console.info(this.answersCategoryIDs)
      //   console.info(this.questions)
      //   // this.exportAnswers()
      // }))
    },
    bindInstance () {
      this.bindings.push(db.collection('instances').doc(this.instanceID).onSnapshot(instance => {
        if (instance.exists) {
          this.$store.commit('admin/setInstance', instance.data())
          this.$store.commit('auth/setInstancesInfo', { instanceID: this.instanceID, data: instance.data() || {} })
        }
      }, (err) => { console.info(err.code) }))
    },
    async bindPersons () {
      const vaccinationQuery = await db.collection('vaccinationData').where('instanceID', '==', this.instanceID).get()
      const vaccinationData = {}
      if (!vaccinationQuery.empty) {
        vaccinationQuery.docs.map(vaccination => {
          vaccinationData[vaccination.id] = vaccination.data()
        })
      }
      this.bindings.push(db.collection('instances').doc(this.instanceID).collection('persons').orderBy('name').limit(6000)
        .onSnapshot(personSnapShot => {
          const personsToAdd = {}
          const personsToEdit = {}
          personSnapShot.docChanges().forEach(change => {
            if (change.type === 'added' || change.type === 'modified') {
              const person = change.doc.data()
              const personData = {
                id: change.doc.id,
                active: person.active,
                guest: typeof person.guest !== 'undefined' && person.guest,
                customID: person.customID,
                name: person.name,
                phoneNumber: person.phoneNumber,
                email: person.email,
                lastAccessRegistration: person.lastAccessRegistration,
                vaccinationStatus: person.vaccinationStatus,
                forbiddenAccess: person.forbiddenAccess,
                nationalPhoneNumber: person.phoneDetails && person.phoneDetails.nationalPhone,
                dialCode: person.phoneDetails && person.phoneDetails.country && person.phoneDetails.country.dialCode,
                documentID: person.documentID,
                registered: person.registered,
                rejected: person.rejected,
                tagIDs: person.tagIDs,
                vaccinationData: vaccinationData[change.doc.id],
                userID: person.userID,
              }
              if (change.type === 'added' && typeof this.$store.state.admin.personsIndexes[change.doc.id] === 'undefined') {
                personsToAdd[change.doc.id] = { personData, newIndex: change.newIndex, oldIndex: change.oldIndex }
              }
              if (change.type === 'modified') {
                // UPDATE doc in VUEX
                personsToEdit[change.doc.id] = { personData, newIndex: change.newIndex, oldIndex: change.oldIndex }
              }
            }
            if (change.type === 'removed') {
              // REMOVE doc in VUEX
              this.$store.commit('admin/deletePerson', { oldIndex: change.oldIndex, personId: change.doc.id })
            }
          })
          if (Object.keys(personsToAdd).length > 0) this.$store.commit('admin/addPersons', personsToAdd)
          if (Object.keys(personsToEdit).length > 0) this.$store.commit('admin/editPersons', personsToEdit)
        }, (err) => { console.info(err.code) }))
    },
    unbindAll () {
      for (const [index, binding] of this.bindings.entries()) {
        binding()
        this.bindings.splice(index, 1)
      }
    },
    changePage (nextPage) {
      if (this.actualPage !== nextPage) {
        this.$f7.views.main.router.navigate(this.pages[nextPage].path)
      }
    },
  },
}
</script>
<style lang="scss">
@import "../css/_brand";
.side-bar{
  padding: 20px 10px;
  width: 220px !important;
  flex-shrink: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: visible;
  background: $dark-color;
}
.sidebar-buttons-icons> svg{
  vertical-align: middle;
}
.sidebar-buttons{
  display: flex !important;
  justify-content: space-between !important;
  margin: 10px !important;
  color: $white !important;
}
.unpressed-buttons:hover{
  background: rgba(255,255,255, 0.1);
}
.arrow-button{
  width: 50px;
  height: 50px;
  position: absolute;
  border-radius: 50%;
  display: inline-block;
  padding: 10px;
  top: 30px;
  left: 200px;
  background: $white;
  z-index: 9998;
  box-shadow: 4px 4px 10px $shadow;
}
.open-arrow-button {
  position: absolute;
  border-radius: 50%;
  display: inline-block;
  padding: 10px;
  left: 5px;
  top: 50px;
  background: $white;
  width: 50px;
  height: 50px;
  z-index: 9998;
  box-shadow: -4px 0px 8px $shadow;
}
#bar-arrow> svg{
  text-align: center;
  position: relative;
  vertical-align: middle;
  z-index: 9999;
}
.arrow-button::before{
  content: '';
  border-radius: 0 20px 20px 0;
  z-index: 1;
  position: absolute;
  display: block;
  background: $white;
  height: 65px;
  left: 20px;
  width: 30px;
  top: -10px;
}
.header{
  display: flex;
  justify-content: space-around;
}
.logo{
  vertical-align: middle;
  height: 32px;
}
.cuidarte{
  vertical-align: middle;
  margin-left: 10px;
  height: 28px;
}
</style>
